const translations = {};

translations["MSG_GUIDE"] = "指南";
translations["MSG_NETWORK_ERROR_MESSAGE"] = "無法顯示頁面。\n請再試一次。";
translations["MSG_APP_ALL"] = "全部";
translations["MSG_APP_BANNER_TITLE"] = "Manande Puzzle App";
translations["MSG_APP_BANNER_SUBTITLE"] = "~ 為孩子們打造的有趣程式設計教育 ~";
translations["MSG_APP_BANNER_INSTALL_BTN"] = "安裝";
translations["MSG_APP_BANNER_SHOW_BTN"] = "顯示";

translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] =
  "正在將應用程式更新至最新版本。";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "應用程式有新版本可用。\n需要更新才能使用最新功能。\n更新將很快完成。";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] =
  "請輸入 6 個字元或以上的密碼。";
translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] = "密碼不符。";
translations["MSG_SIGN_IN_BTN"] = "登入";
translations["MSG_SIGN_UP_BTN"] = "註冊";
translations["MSG_SIGN_IN_WITH_APPLE"] = "使用 Apple 繼續";
translations["MSG_SIGN_UP_WITH_APPLE"] = "使用 Apple 繼續";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "使用 Google 繼續";
translations["MSG_SIGN_IN_WITH_MAIL"] = "使用電子郵件登入";
translations["MSG_SIGN_UP_WITH_MAIL"] = "使用電子郵件註冊";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "沒有帳戶？註冊";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] = "已有帳戶？登入";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "請輸入密碼";
translations["MSG_SIGN_LOGIN_FAILED"] =
  "登入失敗。請檢查您的電子郵件地址和密碼。";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "密碼不匹配";
translations["MSG_SIGN_UP_FAILED"] = "帳戶建立失敗。請重試。";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "請輸入您的電子郵件地址";
translations["MSG_SIGN_EMAIL_INVALID"] = "請輸入有效的電子郵件地址";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] =
  "密碼重置郵件發送失敗。請重試。";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] =
  "※我們將向您註冊的電子郵件地址發送密碼重置連結。";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "發送重置郵件";
translations["MSG_SIGN_EMAIL_SENT"] = "郵件已發送";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] =
  "密碼重置連結已發送。\n請檢查您的郵件。";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "返回登入";
translations["MSG_USER_NAME_LENGTH_LIMIT"] = "請輸入10個字元以內的姓名";
translations["MSG_USER_NAME_REQUIRED"] = "請輸入姓名";
translations["MSG_USER_CREATE_FAILED"] = "用戶建立失敗。請重試。";
translations["MSG_USER_LATEST"] = "最新";
translations["MSG_USER_LIST"] = "用戶列表";
translations["MSG_USER_START_LEARNING_MESSAGE"] =
  "為了開始學習，\n請先建立帳戶。";
translations["MSG_USER_ADD_CHILD_ACCOUNT"] = "新增兒童帳戶";
translations["MSG_USER_START"] = "開始";
translations["MSG_SIGN_USER_MAIL"] = "電子郵件地址";
translations["MSG_SIGN_USER_PASSWORD"] = "密碼";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "重新輸入密碼";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "登入成功。";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "帳戶註冊成功。";
// Account Promotion header
translations["MSG_ACCOUNT_PROMOTION_TITLE"] = "註冊帳號（免費）後，您可以做很多事：";
translations["MSG_ACCOUNT_PROMOTION_MORE_LINK"] = "查看帳戶的好處";

// Account Promotion
translations["MSG_ACCOUNT_PROMOTION_SAVE_TITLE"] = "資料自動保存";
translations["MSG_ACCOUNT_PROMOTION_SAVE_DESC"] =
  "學習進度與作品儲存在雲端，不必擔心遺失。";
translations["MSG_ACCOUNT_PROMOTION_SYNC_TITLE"] = "跨裝置同步";
translations["MSG_ACCOUNT_PROMOTION_SYNC_DESC"] =
  "免費方案也能在任何電腦或平板登入，從上次進度繼續。";
translations["MSG_ACCOUNT_PROMOTION_MULTI_CHILD_TITLE"] = "可建立多個孩子帳號";
translations["MSG_ACCOUNT_PROMOTION_MULTI_CHILD_DESC"] =
  "免費方案也能為兄弟姊妹建立帳號，切換也很簡單。";
translations["MSG_ACCOUNT_PROMOTION_CREATOR_SLOTS_TITLE"] =
  "『自由創作』最多5個作品";
translations["MSG_ACCOUNT_PROMOTION_CREATOR_SLOTS_DESC"] =
  "免費方案也有5個作品數量！可以盡情嘗試。";
translations["MSG_ACCOUNT_PROMOTION_FREE_COURSE_TITLE"] = "免費課程無限制";
translations["MSG_ACCOUNT_PROMOTION_FREE_COURSE_DESC"] =
  "免費方案每天不限次數遊玩學習，還會持續新增課程。";
translations["MSG_ACCOUNT_PROMOTION_SIGNUP_BTN"] = "建立帳戶";
translations["MSG_ACCOUNT_PROMOTION_LATER_BTN"] = "稍後";

// Account Promotion Table
translations["MSG_ACCOUNT_PROMOTION_TABLE_HEADER_TRIAL"] = "體驗方案";
translations["MSG_ACCOUNT_PROMOTION_TABLE_HEADER_FREE"] = "免費方案";
translations["MSG_ACCOUNT_PROMOTION_TABLE_CURRENT_LABEL"] = "帳號註冊前";
translations["MSG_ACCOUNT_PROMOTION_TABLE_RECOMMENDED_LABEL"] = "帳號註冊後";
translations["MSG_ACCOUNT_PROMOTION_TABLE_AFTER_SIGNUP_LABEL"] = "註冊後";
translations["MSG_ACCOUNT_PROMOTION_TABLE_USER_COUNT"] = "可新增的用戶數";
translations["MSG_ACCOUNT_PROMOTION_TABLE_USER_TRIAL"] = "最多1人";
translations["MSG_ACCOUNT_PROMOTION_TABLE_USER_FREE"] = "最多2人";
translations["MSG_ACCOUNT_PROMOTION_TABLE_CREATOR_COUNT"] = "在『自由創作』中可創建的應用數量";
translations["MSG_ACCOUNT_PROMOTION_TABLE_CREATOR_TRIAL"] = "最多1個";
translations["MSG_ACCOUNT_PROMOTION_TABLE_CREATOR_FREE"] = "最多5個";
translations["MSG_ACCOUNT_PROMOTION_TABLE_COURSE_ACCESS"] = "在『課程學習』中可遊玩的課程數";
translations["MSG_ACCOUNT_PROMOTION_TABLE_COURSE_TRIAL"] = "最多第2關";
translations["MSG_ACCOUNT_PROMOTION_TABLE_COURSE_FREE"] = "最多第7關";
translations["MSG_ACCOUNT_PROMOTION_TABLE_SYNC"] = "儲存遊戲資料到雲端";
translations["MSG_ACCOUNT_PROMOTION_TABLE_SYNC_TRIAL"] = "✕";
translations["MSG_ACCOUNT_PROMOTION_TABLE_SYNC_FREE"] = "○";

// Redirect Sign Up modal (per source)
translations["MSG_REDIRECT_SIGNUP_TITLE_COURSE"] = "課程已達上限";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_COURSE"] =
  "訪客只能玩算法遊樂場的關卡1和2\n如果想玩更多，請詢問家長或監護人";
translations["MSG_REDIRECT_SIGNUP_TITLE_CREATOR"] = "無法再建立更多作品";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_CREATOR"] =
  "訪客僅能建立 1 個作品\n如果想建立更多，請詢問家長或監護人";
translations["MSG_REDIRECT_SIGNUP_TITLE_CREATE_USER"] = "無法新增孩子使用者";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_CREATE_USER"] =
  "訪客無法新增孩子使用者\n如果想新增使用者，請詢問家長或監護人";
translations["MSG_REDIRECT_SIGNUP_TITLE_USER_ACCOUNT"] = "無法管理使用者";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_USER_ACCOUNT"] =
  "管理使用者需要帳戶\n免費方案或以上可管理使用者設定\n註冊帳戶即可獲得免費方案";
translations[
  "MSG_REDIRECT_SIGNUP_TITLE_PARENT_SETTINGS_USER_ACCOUNT_SETTINGS"
] = "無法管理帳戶";
translations[
  "MSG_REDIRECT_SIGNUP_MESSAGE_PARENT_SETTINGS_USER_ACCOUNT_SETTINGS"
] = "訪客無法變更帳戶設定\n需要註冊家長帳戶";
translations["MSG_REDIRECT_SIGNUP_TITLE_PARENT_SETTINGS_CHILD_USER_SETTINGS"] =
  "無法管理使用者";
translations[
  "MSG_REDIRECT_SIGNUP_MESSAGE_PARENT_SETTINGS_CHILD_USER_SETTINGS"
] = "訪客無法管理孩子使用者\n需要註冊家長帳戶";
translations["MSG_REDIRECT_SIGNUP_TITLE_PARENT_SETTINGS_LINK_PARENTS_APP"] =
  "無法使用守護App";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_PARENT_SETTINGS_LINK_PARENTS_APP"] =
  "訪客無法與守護App連結\n需要註冊家長帳戶";
translations["MSG_REDIRECT_SIGNUP_TITLE_PARENT_SETTINGS_ENABLE_LAB"] =
  "無法使用企業代碼";
translations["MSG_REDIRECT_SIGNUP_MESSAGE_PARENT_SETTINGS_ENABLE_LAB"] =
  "訪客無法輸入企業認證代碼\n需要註冊家長帳戶";
translations["MSG_REDIRECT_SIGNUP_LEARN_MORE"] = "了解更多帳戶的好處";
translations["MSG_REDIRECT_SIGNUP_TO_PARENTS_BTN"] = "給家長";
translations["MSG_SIGN_IN_FAILED_TITLE"] = "登入失敗";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] = "電子郵件地址或密碼不正確。";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "忘記密碼？";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "重設密碼";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_SUCCESS_CONTENT"] =
  "已將密碼重設連結傳送到指定的電子郵件地址。";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] = "目前密碼";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "新密碼";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] =
  "確認密碼";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SEND_BTN"] = "變更";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] = "密碼變更成功。";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] =
  "輸入的密碼不正確。";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] =
  "此電子郵件地址已被使用。";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "家長";

translations["MSG_DATETIME_PERIOD"] = "期間";
translations["MSG_DATETIME_PERIOD_RECENTLY"] = "最近";
// 台灣常用格式
translations["MSG_DATETIME_FORMAT_HOUR"] = "時";
translations["MSG_DATETIME_FORMAT_MINUTE"] = "分";

translations["MSG_INEXUS_OFFICIAL"] = "Manande Puzzle";
translations["MSG_INEXUS_OFFICIAL_CONTACT"] = "Manapuzzle 支援";
translations["MSG_REVIEW_RATING_TITLE"] = "請評價\n'Manande Puzzle'！";
translations["MSG_REVIEW_FEEDBACK_TITLE"] = "意見箱";
translations["MSG_REVIEW_SEND_RATING_CONFIRM"] = "傳送";
translations["MSG_REVIEW_SEND_FEEDBACK_CONFIRM"] = "傳送意見回饋";
translations["MSG_REVIEW_THANKS_BUBBLE_TEXT"] = "非常\n感謝您！";
translations["MSG_REVIEW_FEEDBACK_THANKS_TEXT"] =
  "我們期待您繼續支持\n'Manande Puzzle'。";

translations["MSG_REVIEW_FEEDBACK_TYPE_APP"] = "整個應用程式";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE"] = "'透過課程學習'";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR"] = "'自由創作'";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "沒有抱怨";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] = "不知道\n如何使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "難以使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "太難";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "太簡單";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "關卡\n太多";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "關卡\n太少";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] =
  "無法\n順利創作";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] = "難以\n使用";
translations["MSG_REVIEW_FEEDBACK_PLACEHOLDER"] = "在此自由填寫";
translations["MSG_USER_PROFILE_ADD_USER_TITLE"] = "新增使用者";
translations["MSG_USER_PROFILE_ADD_USER_BTN"] = "新增";
translations["MSG_USER_PROFILE_ADD_USER_MESSAGE"] = "請為新使用者命名。";
translations["MSG_USER_PROFILE_CHANGE_USER"] = "切換使用者";
translations["MSG_USER_PROFILE_CHANGE_USER_TITLE"] = "切換使用者？";
translations["MSG_USER_PROFILE_CHANGE_USER_MESSAGE"] =
  "前往使用者清單頁面切換使用者。";
translations["MSG_USER_PROFILE_CHANGE_USER_SUCCESS"] = "已切換使用者。";
translations["MSG_USER_PROFILE_CHANGE_USER_FAILED"] = "切換使用者失敗。";
translations["MSG_USER_PROFILE_MAX_USER_TITLE"] = "無法新增使用者";
translations["MSG_USER_PROFILE_MAX_USER_MESSAGE"] =
  "目前最多只能建立 2 個使用者。\n若可建立超過 2 個使用者時，我們會通知您。";
translations["MSG_USER_PROFILE_SHOW_USER_LIST_BTN"] = "更多";
translations["MSG_USER_PROFILE_USER_STATUS"] = "狀態";
translations["MSG_USER_SELECTION_PROMPT"] = "請選擇要玩的人";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "姓名%{random}";
translations["MSG_GUEST_USER_PROFILE_DEFAULT_NAME"] = "游客%{random}";
translations["MSG_USER_PROFILE_FIELD_NAME"] = "暱稱";
translations["MSG_USER_PROFILE_FIELD_NAME_PLACEHOLDER"] = "輸入暱稱";
translations["MSG_USER_PROFILE_INPUT_TITLE"] = "選擇你的名字和圖示吧！";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT"] = "給自己取個名字吧";
translations["MSG_USER_PROFILE_SELECT_ICON_TITLE"] = "選擇你的圖示";
translations["MSG_USER_PROFILE_FIELD_GENDER"] = "性別";
translations["MSG_USER_PROFILE_FIELD_GENDER_MALE"] = "男性";
translations["MSG_USER_PROFILE_FIELD_GENDER_FEMALE"] = "女性";
translations["MSG_USER_PROFILE_FIELD_GENDER_NONE"] = "背景";
translations["MSG_USER_PROFILE_FIELD_GENDER_ALL"] = "全部";
translations["MSG_USER_PROFILE_FIELD_AGE"] = "年齡";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY"] = "生日";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_MONTH"] = "月";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_DAY"] = "日";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_AGE"] = "歲";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_MONTH_ERROR"] =
  "請使用 1 到 12 之間的數字。";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_DAY_ERROR"] =
  "請使用 1 到 31 之間的數字。";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_AGE_ERROR"] =
  "請使用 0 到 99 之間的數字。";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_MONTH_PLACEHOLDER"] = "1";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_DATE_PLACEHOLDER"] = "1";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_AGE_PLACEHOLDER"] = "0";
translations["MSG_USER_PROFILE_STATUS_COURSE_CLEARED"] = "已完成\n課程";
translations["MSG_USER_PROFILE_STATUS_PROJECTS"] = "已建立\n應用程式";
translations["MSG_USER_PROFILE_STATUS_PUBLISHED_PROJECTS"] = "已發佈\n應用程式";
translations["MSG_USER_PROFILE_STATUS_PROJECT_RECEIVED_FAVORITE"] =
  "收到的\n讚數";
translations["MSG_USER_PROFILE_PROGRESS"] = "紀錄";
translations["MSG_USER_PROFILE_PROGRESS_NEW_TITLE"] = "新！";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_LEVEL_TITLE"] = "等級";
translations["MSG_USER_PROFILE_PROGRESS_COURSE"] = "透過課程\n學習";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CHART_DATE_TITLE"] = "天";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_TITLE"] = "已完成數量";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR"] = "自由\n創作";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_START"] =
  "總計";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_END"] = "人";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_START"] =
  "總計";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_END"] =
  "讚";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_VIEWED_TITLE"] = "訪客";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_FAVORITED_TITLE"] =
  "讚數";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY"] =
  "來建立一個應用程式吧！";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_GOTO_BTN"] = "前往「自由創作」";
translations["MSG_USER_PROFILE_INFO"] = "我";
translations["MSG_USER_PROFILE_ICON_BTN"] = "變更圖示";
translations["MSG_USER_PROFILE_CASE_BTN"] = "變更外殼";
translations["MSG_USER_PROFILE_STOCK"] = "素材";
translations["MSG_USER_PROFILE_SETTING"] = "設定";
translations["MSG_USER_PROFILE_NAME_ERROR_TITLE"] = "註冊失敗。";
translations["MSG_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "包含無法使用的字元或文字。請再試一次。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_TITLE"] = "註冊失敗。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "包含無法使用的字元或文字。請再試一次。";
translations["MSG_USER_PROFILE_MESSAGE"] = "郵件";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_TITLE"] = "%{type} 詢問";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"] =
  "感謝您的詢問！\n請在下方的輸入欄位中填寫您的問題。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_INPUT_AUTO_REPLY"] =
  translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"];
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_TALK_WELCOME_TEXT"] =
  " 加入了。";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_SEND_BTN"] = "傳送";

// Official welcome messages (dynamic index 0..3)
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_0"] =
  "%{name}，歡迎來到 'Manande Puzzle'！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_1"] =
  "在 'Manande Puzzle' 中，您可以邊玩有趣的拼圖邊學習程式設計。\n首先，請從「透過課程學習」開始，依序學習如何遊玩和學習！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_2"] =
  "當您大致了解演算法和程式設計方法後，請嘗試在「自由創作」中隨心所欲地建立您自己的應用程式。";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_3"] =
  "來試試 'Manande Puzzle' 吧！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING"] = " 傳送了評價。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING_AUTO_REPLY"] =
  "感謝您的評價！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_AUTO_REPLY"] =
  "感謝您的意見回饋！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TITLE"] = "意見回饋";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TYPE_OTHER"] =
  "・其他：";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_PLACEHOLDER"] = "在此自由填寫";
translations["MSG_USER_PROFILE_MESSAGE_PUBLISHED_PROJECT_MESSAGE"] =
  '已發佈應用程式 "%{name}"。';

translations["MSG_TOP_TUTORIAL_FIRST_WELCOME_MESSAGE"] =
  "如果是第一次\n請觀看教學！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_1"] = "今天也一起\n加油吧！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_2"] =
  "一起快樂地\n用拼圖學習吧！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_3"] =
  "和我一起\n學習程式設計吧！";
translations["MSG_TOP_TUTORIAL_APP_START"] = "開始";
translations["MSG_TOP_TUTORIAL_START"] = "觀看教學";
translations["MSG_TOP_TUTORIAL_DONOT_SHOW"] = "下次不再顯示";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_1"] = "關於 'Manande Puzzle'";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_2"] = "關於「透過\n課程學習」";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_3"] = "關於「自由創作」";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_4"] = "說明按鈕與\n我的頁面";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_5"] = "關於家長\n專用選單";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_6"] = "進行應用程式\n設定";
translations["MSG_TOP_TUTORIAL_CLOSE_PAGE"] = "關閉此畫面";
translations["MSG_TOP_TUTORIAL_NEXT_PAGE"] = "下一步";
translations["MSG_TOP_TUTORIAL_START_APP"] = "開始 'Manande Puzzle'";

translations["MSG_ONBOARDING_STEP_TITLE_1"] = "「まなんでパズル」\nについて";
translations["MSG_ONBOARDING_STEP_TITLE_2"] = "「コースでまなぶ」\nについて";
translations["MSG_ONBOARDING_STEP_TITLE_3"] = "「じゆうにつくる」\nについて";
translations["MSG_ONBOARDING_STEP_TITLE_4"] = "ヘルプボタンと\nマイページ";
translations["MSG_ONBOARDING_STEP_TITLE_5"] =
  "保護者の方用の\nメニューについて";
translations["MSG_ONBOARDING_STEP_TITLE_6"] = "アカウントの\n作成";
translations["MSG_ONBOARDING_STEP_6_MAIN_TITLE"] = "歡迎來到學學拼圖！";
translations["MSG_ONBOARDING_STEP_6_SIGN_UP_TITLE"] = "註冊";
translations["MSG_ONBOARDING_STEP_6_SIGN_IN_TITLE"] = "登入";
translations["MSG_ONBOARDING_STEP_6_GUEST_TITLE"] = "訪客試用";
translations["MSG_ONBOARDING_FIRST_TIME"] = "第一次使用者";
translations["MSG_ONBOARDING_FIRST_TIME_SUB"] = "開始新的冒險！";
translations["MSG_ONBOARDING_EXISTING_USER"] = "已在遊玩";
translations["MSG_ONBOARDING_EXISTING_USER_SUB"] = "家長（登入或註冊）";

// AuthSelection
translations["MSG_AUTH_SELECTION_TITLE"] = "選擇您的帳戶";
translations["MSG_AUTH_SELECTION_SUBTITLE"] = "請選擇登入或註冊";
translations["MSG_AUTH_SELECTION_INSTRUCTION"] =
  "已有帳戶請「登入」，首次使用請「註冊」。";
translations["MSG_AUTH_SIGN_IN"] = "登入";
translations["MSG_AUTH_SIGN_IN_DESC"] = "使用現有帳戶登入";
translations["MSG_AUTH_SIGN_UP"] = "註冊";
translations["MSG_AUTH_SIGN_UP_DESC"] = "建立新帳戶";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "通知";

translations["MSG_BACK_BTN"] = "返回";
translations["MSG_CLOSE_BTN"] = "關閉";
translations["MSG_CANCEL_BTN"] = "取消";
translations["MSG_CONFIRM_BTN"] = "確定";
translations["MSG_STOP_BTN"] = "停止";
translations["MSG_DELETE_BTN"] = "刪除";
translations["MSG_PARENTS_CANCEL_BTN"] = "取消";
translations["MSG_PARENTS_CONFIRM_BTN"] = "確定";
translations["MSG_PARENTS_DELETE_BTN"] = "刪除";
translations["MSG_PARENTS_KIDS_USER_DELETE_BTN"] = "刪除此使用者";

translations["MSG_ERROR_RELOAD_BTN"] = "重試";
translations["MSG_ERROR_TITLE"] = "無法正確完成處理。";
translations["MSG_ERROR_MESSAGE"] =
  "請再試一次。\n如果重試後仍然出現此畫面，請諮詢家長。";
// 台灣常用格式

translations["MSG_TOAST_FAILED"] = "失敗";
translations["MSG_TOAST_SEND_FAILED"] = "傳送失敗";
translations["MSG_TOAST_EDIT_SUCCESS"] = "變更成功";
translations["MSG_TOAST_DELETED_SUCCESS"] = "刪除成功";
translations["MSG_TOAST_PUBLISHED_SUCCESS"] = "發佈成功";
translations["MSG_TOAST_DISABLE_PUBLISHED_SUCCESS"] = "取消發佈成功";
translations["MSG_TOAST_ENABLE_COPIED_SUCCESS"] = "允許複製";
translations["MSG_TOAST_DISABLE_COPIED_SUCCESS"] = "禁止複製";
translations["MSG_TOAST_RESTORE_SUCCESS"] = "已還原應用程式";
translations["MSG_TOAST_COPY"] = "已複製。";
translations["MSG_TOAST_PAST"] = "已貼上。";
translations["MSG_TOAST_UNDO"] = "已復原。";
translations["MSG_TOAST_REDO"] = "已重做。";
translations["MSG_TOAST_INSERT_ASSET_IMAGE_SUCCESS"] = "已新增圖片。";
translations["MSG_TOAST_INSERT_ASSET_TEMPLATE_SUCCESS"] = "已新增範本。";
translations["MSG_TOAST_CONTACT_SEND"] = "已傳送詢問。";
translations["MSG_SETTING_TOP_TUTORIAL"] = "應用程式啟動畫面";
translations["MSG_SETTING_TOP_TUTORIAL_SHOW"] = "啟動時顯示";
translations["MSG_SETTING_TOP_TUTORIAL_NOT_SHOW"] = "不顯示";
translations["MSG_SETTING_APP_LANGUAGE"] = "應用程式顯示語言";
translations["MSG_SETTING_SOUND"] = "音效";
translations["MSG_SETTING_BGM"] = "音樂";
translations["MSG_SETTING_PARENT_GATE"] = "家長專用";
translations["MSG_SETTING_GO_TO_TOP"] = "首頁";
translations["MSG_SETTING_GO_TO_CONTACT"] = "聯絡我們";
translations["MSG_SETTING_GO_TO_REVIEW"] = "評價應用程式";
translations["MSG_SETTING_GO_TO_TUTORIAL"] = "教學";
translations["MSG_SETTING_GO_TO_PARENTS_LINK"] = "守護 App";
translations["MSG_SETTING_GO_TO_LAB"] = "輸入企業代碼";
translations["MSG_SETTING_CLOSE_BTN"] = "關閉此畫面";
translations["MSG_SETTING_BACK_TO_BTN"] = "返回上一畫面";

translations["MSG_SETTING_TITLE_TOP"] = "家長選單";
translations["MSG_SETTING_CATEGORY_TITLE_APP_ACCOUNT"] = "帳戶";
translations["MSG_SETTING_CATEGORY_TITLE_APP_CONTENT"] = "內容";
translations["MSG_SETTING_CATEGORY_TITLE_APP_INFO"] = "應用程式";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "檢視課程答案";
translations["MSG_SETTING_TITLE_PARENTS_LINK"] = "守護 App";
translations["MSG_SETTING_TITLE_ENABLE_LAB"] = "內容驗證";
translations["MSG_SETTING_TITLE_PARENTS_USER_ACCOUNT"] = "帳戶管理";
translations["MSG_SETTING_TITLE_PARENTS_USER_PROFILE"] = "使用者管理";
translations["MSG_SETTING_TITLE_SUBSCRIPTION"] = "購買方案";
translations["MSG_SETTING_TITLE_SIGN_PASSWORD_CHANGE"] = "變更密碼";
translations["MSG_SETTING_TITLE_PARENTS_USER_UNSUBSCRIBE"] = "刪除帳戶";
translations["MSG_SETTING_TITLE_NOTIFICATION"] = "通知";
translations["MSG_SETTING_MENU_PROJECT_PUBLISH"] = "允許發佈應用程式";
translations["MSG_SETTING_MENU_PROJECT_COPIED"] = "允許複製應用程式";
translations["MSG_SETTING_MENU_LANGUAGE"] = "應用程式顯示語言";
translations["MSG_SETTING_MENU_COURSE_ANSWER_BTN"] = "檢視課程\n答案";
translations["MSG_SETTING_MENU_NOTIFICATION_TITLE"] =
  translations["MSG_SETTING_TITLE_NOTIFICATION"];
translations["MSG_SETTING_MENU_PARENTS_USER_BTN"] =
  translations["MSG_SETTING_TITLE_PARENTS_USER_PROFILE"];
translations["MSG_SETTING_MENU_SIGN_WARNING_TITLE"] = "要不要建立帳戶？";
translations["MSG_SETTING_MENU_SIGN_WARNING_MESSAGE"] =
  "訪客使用者每天只能玩1個課程，自由創作只能建立1個專案。\n建立帳戶後，您可以每天無限次玩課程，自由創作最多可以建立5個專案！\n將跳轉到帳戶建立頁面。";

translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "前往 'Manande Puzzle' 網站";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "服務條款";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "隱私權政策";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "聯絡我們";
translations["MSG_SETTING_APP_SETTING_USER_ACTIVE"] = "啟用此使用者";
// 使用計數範例
translations["MSG_SETTING_DATA_DELETE_SUCCESS"] = "已刪除使用者。";
translations["MSG_SETTING_PARENTS_MAX_USER_TITLE"] = "無法新增使用者";
translations["MSG_SETTING_PARENTS_MAX_USER_MESSAGE"] =
  "目前最多只能建立 2 位使用者。\n當可以建立超過 2 位使用者時，我們會通知您。";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "啟用使用者";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] = "啟用此使用者。";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "停用使用者";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] =
  "停用此使用者。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] =
  "無法啟用";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "最多只能有 4 位有效使用者。\n若要啟用此使用者，請先停用（或刪除）另一位不需要的使用者。";
translations["MSG_SETTING_PARENTS_ADD_DEVICE_USER_MAX_WARNING_TITLE"] =
  "請檢查新增使用者的啟用狀態";
translations["MSG_SETTING_PARENTS_ADD_DEVICE_USER_MAX_WARNING_MESSAGE"] =
  "已登入帳戶的使用者總數超過 4 人。\n同時最多只能有 4 位有效使用者。\n如果您想啟用這次新增的使用者，請先停用（或刪除）其他不需要的使用者。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] =
  "無法變更";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "至少需要一位使用者。\n無法再減少使用者數量。";
translations["MSG_SETTING_PARENTS_REMOVE_KIDS_USER_TITLE"] = "刪除使用者";
translations["MSG_SETTING_PARENTS_REMOVE_KIDS_USER_MESSAGE"] =
  "刪除使用者將移除此使用者的所有資料。\n您將無法再使用此使用者。";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "登出";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "登出帳戶後，您將無法使用目前的使用者遊玩。\n使用者資訊已儲存在帳戶中，如果您想再次使用相同的使用者遊玩，請使用此帳戶重新登入。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] =
  "【重要】請注意";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "從 'Manande Puzzle' 刪除您的帳戶將刪除以下所有資料：\n・註冊的個人資料和帳戶資訊。\n・所有已註冊的使用者資訊。\n・使用者在「自由創作」中建立的應用程式。\n・使用者在「透過課程學習」中完成的所有成績和成就。\n・使用者進行的「對話紀錄」等。\n* 【重要】刪除已登入的帳戶將刪除與此帳戶相關的所有資料，請務必小心。\n* 【重要】此操作在任何情況下都無法復原。刪除帳戶時請務必小心。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] =
  "請告訴我們刪除帳戶的原因。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] =
  "您確定要刪除帳戶嗎？";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "刪除帳戶將移除所有資料，包括帳戶和使用者。\n帳戶刪除後無法復原。請小心操作。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_NAME"] = "顯示名稱";
translations["MSG_SETTING_PARENTS_USER_PROFILE_SAVE_BTN"] = "儲存";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL"] = "電子郵件地址";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL_VERIFIED"] =
  "電子郵件驗證";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL_VERIFIED_DONE"] = "已驗證";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL_VERIFIED_NOT_YET"] =
  "傳送驗證連結";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT"] = "連結社群\n帳戶";
translations[
  "MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"
] = "無法連結";
translations[
  "MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"
] = "社群帳戶已連結到另一個帳戶。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_WITH_APPLE"] =
  "連結 Apple";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_WITH_GOOGLE"] =
  "連結 Google";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_UNLINK_WITH_APPLE"] =
  "取消連結 Apple";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_UNLINK_WITH_GOOGLE"] =
  "取消連結 Google";
translations["MSG_SETTING_PARENTS_USER_PROFILE_CREATED_AT"] = "帳戶註冊日";
translations["MSG_SETTING_PARENTS_USER_KIDS_PROFILE_CREATED_AT"] = "註冊日";
translations["MSG_SETTING_PARENTS_USER_PROFILE_LATEST_AT"] = "最後登入日";
translations["MSG_SETTING_PARENTS_USER_PROFILE_GOTO_CHANGE_PASSWORD_BTN"] =
  "變更密碼";
translations["MSG_SETTING_PARENTS_USER_PROFILE_SIGN_OUT_BTN"] = "登出";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] = "刪除帳戶";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ADD_USER"] = "新增使用者";
translations["MSG_SETTING_PARENTS_USER_PROFILE_DISPLAY_NAME_LIMIT"] =
  "%{limit}字元以內。";

translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "選擇課程";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "選擇關卡";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "選擇等級";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "關卡";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "等級";

translations["MSG_SETTING_PARENTS_LINK_DOWNLOAD_TITLE"] = "下載守護 App";
translations["MSG_SETTING_PARENTS_LINK_DOWNLOAD_DESCRIPTION"] =
  "若您想在不使用QR碼的情況下新增使用者，請在「守護App」中輸入此驗證碼。";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_TITLE"] =
  "將此裝置上的使用者新增到已登入的帳戶。";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_DESCRIPTION"] =
  "若您想在不使用QR碼的情況下新增使用者，請在「守護App」中輸入此驗證碼。";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] = "驗證碼";

translations["MSG_CONTACT_TITLE"] = "聯絡我們";
translations["MSG_CONTACT_TYPE_TITLE"] = "選擇聯絡類型";
translations["MSG_CONTACT_DETAIL_TITLE"] = "請詳細描述您的問題或需求。";
translations["MSG_CONTACT_TYPE_HOW_TO"] = "不知道\n如何使用";
translations["MSG_CONTACT_TYPE_BUG"] = "無法正常運行";
translations["MSG_CONTACT_TYPE_REQUEST"] = "希望新增的功能";
translations["MSG_CONTACT_TYPE_OTHER"] = "其他問題";
translations["MSG_CONTACT_SEND_BTN"] = "送出";

translations["MSG_PARENT_GATE_WARNING"] = "此頁面需要\n家長的同意才能進入。";
translations["MSG_PARENT_GATE_TITLE"] = "給家長的提示";
translations["MSG_PARENT_GATE_DESCRIPTION"] =
  "此後的頁面將包含保護者專用的設定和帳戶信息。\n要顯示此頁面，請按照以下圖示操作。";
translations["MSG_PARENT_GATE_CLOSE_BTN"] =
  translations["MSG_SETTING_CLOSE_BTN"];
translations["MSG_PARENT_GATE_CONFIRM_BTN"] = "確定";
translations["MSG_PARENT_GATE_QUESTION_TITLE"] = "請按照以下順序點擊圖示：";
translations["MSG_PARENT_GATE_SHAPE_RECT"] = "矩形";
translations["MSG_PARENT_GATE_SHAPE_STAR"] = "星形";
translations["MSG_PARENT_GATE_SHAPE_CIRCLE"] = "圓形";
translations["MSG_PARENT_GATE_SHAPE_TRIANGLE"] = "三角形";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "保護者";

translations["MSG_COURSE_COMING_SOON_WARNING_MESSAGE"] =
  "這個卡帶還不能玩。\n再等一下吧！";
translations["MSG_COURSE_START_BTN"] = "開始";
translations["MSG_COURSE_GOTO_MAP_BTN"] = "地圖";
translations["MSG_COURSE_STAGE_CLEAR_TITLE"] = "這裡已經完成了！";
translations["MSG_COURSE_LEVEL_OVERVIEW_SUMMARY"] = "在這個等級中學習";
translations["MSG_COURSE_LEVEL_OVERVIEW_START_BTN"] = "開始";
translations["MSG_COURSE_GAME_TIPS_NEXT_BTN"] = "下一關";
translations["MSG_COURSE_GAME_TIPS_BACK_BTN"] = "上一關";
translations["MSG_COURSE_GAME_TIPS_ACTION_BTN"] = "試試看";
translations["MSG_COURSE_GAME_HINT_BTN"] = "提示";
translations["MSG_COURSE_GAME_CLEAR"] = "完成";
translations["MSG_COURSE_GAME_SCORE_TEXT"] = "獲得的物品";
translations["MSG_COURSE_GAME_SCORE_STATUS"] = "這/%{total}個";
translations["MSG_COURSE_GAME_START_BTN"] = "開始！";
translations["MSG_COURSE_GAME_RESET_BTN"] = "重來";
translations["MSG_COURSE_GAME_SUCCESS_TEXT"] = "恭喜！你完成了這個等級！";
translations["MSG_COURSE_GAME_SUCCESS_REVIEW_BTN"] = "再試一次";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_LEVEL_BTN"] = "進入下一個等級";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_STAGE_BTN"] = "進入下一個關卡";
translations["MSG_COURSE_GAME_FAILED_TITLE"] = "失敗！";
translations["MSG_COURSE_GAME_FAILED_TEXT"] =
  "再試一次吧！\n\n當你覺得難以理解時，\n可以參考提示。";
translations["MSG_COURSE_GAME_FAILED_RESET_BTN"] = "再試一次";
translations["MSG_COURSE_GAME_STAGE_CLEAR"] = "恭喜！你完成了這個關卡！";
translations["MSG_COURSE_ALL_GAME_STAGE_CLEAR"] =
  "恭喜！\n現在 你已經完成了\n所有 關卡！\n新的關卡將會在\n這裡出現，請耐心等待！";
translations["MSG_COURSE_PROGRAM_RUN"] = "開始";
translations["MSG_COURSE_COORDINATE_X"] = "橫向位置（X座標）";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_NEXT_BTN"] = "下一關";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_LATER_BTN"] = "稍後再看";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CONTINUE_BTN"] = "繼續指南";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_ACTION_BTN"] = "試試看";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CLOSE_BTN"] = "結束指南";
translations["MSG_CREATOR_CREATE_APP"] = "創建新應用程式";
translations["MSG_CREATOR_CREATE_APP_TITLE"] = "製作應用程式";
translations["MSG_CREATOR_CREATE_APP_NAME"] = "請為您的應用程式命名。";
translations["MSG_CREATOR_CREATE_APP_NAME_PREFIX"] = "應用程式";
translations["MSG_CREATOR_APP_DETAIL_BTN"] = "詳細";
translations["MSG_CREATOR_RUN_APP_BTN"] = "運行";
translations["MSG_CREATOR_APP_MY_APPS"] = "我的應用程式";
translations["MSG_CREATOR_APP_SHARED_APPS"] = "大家的應用程式";
translations["MSG_CREATOR_APP_SHARED_APPS_EMPTY_MESSAGE"] =
  "沒有符合條件的應用程式。\n請更改條件後再試一次。";
translations["MSG_CREATOR_APP_DELETED_APPS"] = "垃圾桶";
translations["MSG_CREATOR_APP_DELETED_APPS_MESSAGE"] =
  "選擇您想移回\n「我的應用程式」的應用程式。\n（最多保留5個\n最近刪除的應用程式）";
translations["MSG_CREATOR_APP_SETTING_TITLE"] = "應用程式設定";
translations["MSG_CREATOR_APP_SETTING_APP_NAME"] = "應用程式名稱";
translations["MSG_CREATOR_APP_SETTING_APP_TAG"] = "標籤";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_TITLE"] =
  "發佈至「共享應用程式」？";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_OFF"] = "不公開";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_ON"] = "公開";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_TITLE"] =
  "其他使用者可以複製";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_OFF"] = "禁止複製";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_ON"] = "允許複製";
translations["MSG_CREATOR_APP_SETTING_APP_CHANGE_COVER_PAGE_BTN"] = "更換封面";
translations["MSG_CREATOR_APP_DETAIL_APP_AUTHOR"] = "最初製作的人";
translations["MSG_CREATOR_APP_DETAIL_APP_EDITOR"] = "重新製作的人";
translations["MSG_CREATOR_APP_NAME_PLACEHOLDER"] = "請輸入名稱";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_TITLE"] = "應用程式描述";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_NONE"] = "沒有描述";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_PLACEHOLDER"] =
  "請輸入應用程式描述";
translations["MSG_CREATOR_APP_DETAIL_TITLE_APP_CODE"] = "應用程式\n代碼";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP"] = "大家的\n應用程式";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_PUBLISHED"] = "已發佈";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_NOT_PUBLISHED"] =
  "未發佈";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS"] = "其他\n使用者";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_ENABLE"] = "可以複製";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_DISABLE"] = "無法複製";
translations["MSG_CREATOR_APP_DETAIL_APP_DELETED_AT"] = "刪除\n日期";
translations["MSG_CREATOR_APP_EDITOR_BTN"] = "製作";
translations["MSG_CREATOR_APP_COMPLETELY_BTN"] = "完全刪除";
translations["MSG_CREATOR_APP_RESTORE_BTN"] = "恢復原狀";
translations["MSG_CREATOR_APP_DELETE_WARNING_TITLE"] = "確定要刪除應用程式嗎？";
translations["MSG_CREATOR_APP_DELETE_WARNING_MESSAGE"] =
  "確定要刪除「%{name}」嗎？\n刪除後將無法恢復，請小心操作。\n應用程式將無法使用。";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_TITLE"] = "確定要刪除圖片嗎？";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_MESSAGE"] =
  "確定要刪除「%{name}」嗎？\n刪除後將無法恢復，請小心操作。";
translations["MSG_CREATOR_CREATE_APP_PICKUP_NAME"] = "精選";
translations["MSG_CREATOR_CREATE_APP_PICKUP_MONTH_TITLE"] = "%{month}月的";
translations["MSG_CREATOR_CREATE_APP_PICKUP_SUBTITLE"] =
  "看看有什麼吸引您的應用程式！";
translations["MSG_CREATOR_APP_PUBLISH_TITLE"] = "發佈至「共享應用程式」？";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_TITLE"] = "無法發佈應用程式";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_MESSAGE"] =
  "發佈應用程式需要保護者同意。\n請從保護者選單中啟用。";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_TITLE"] =
  "停止發佈至「共享應用程式」？";
translations["MSG_CREATOR_APP_PUBLISH_WARNING"] =
  "將「%{name}」發佈至「共享應用程式」。\n其他使用者將可以使用此應用程式。";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_WARNING"] =
  "將「%{name}」設為不公開。\n不發佈後，其他使用者將無法使用此應用程式。";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_ENABLE"] = "允許複製並發佈";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_DISABLE"] = "禁止複製並發佈";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_NOTICE"] =
  "※應用程式可以在稍後停止發佈。";
translations["MSG_CREATOR_PUBLISH_CONFIRM_BTN"] = "發佈";
translations["MSG_CREATOR_DISABLE_PUBLISH_CONFIRM_BTN"] = "不公開";
translations["MSG_CREATOR_APP_ENABLE_COPIED_TITLE"] = "此應用程式的複製設定";
translations["MSG_CREATOR_APP_DISABLE_COPIED_TITLE"] = "此應用程式的複製設定";
translations["MSG_CREATOR_APP_ENABLE_COPIED_MESSAGE"] =
  "其他使用者可以複製「%{name}」。";
translations["MSG_CREATOR_APP_DISABLE_COPIED_MESSAGE"] =
  "其他使用者無法複製「%{name}」，禁止複製。";
translations["MSG_CREATOR_APP_LIMIT_WARNING_TITLE"] = "無法製作應用程式";
translations["MSG_CREATOR_APP_LIMIT_WARNING_MESSAGE"] =
  "目前只能製作5個應用程式。\n如果您想製作新的應用程式，請刪除舊的應用程式。\n當您可以製作超過5個應用程式時，我們會通知您。";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_TITLE"] = "此圖片無法使用";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_MESSAGE"] =
  "只能添加最新製作的50張圖片。\n其他圖片也可以使用，請告訴我們。";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_TITLE"] =
  "無法刪除發佈中的應用程式";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_MESSAGE"] =
  "大家的應用程式中正在發佈的應用程式無法刪除。\n如果您想刪除應用程式，請先停止發佈。\n";
translations["MSG_CREATOR_TOP_TUTORIAL_APP_LIMIT_WARNING_TITLE"] =
  "無法執行「指南」";
translations["MSG_CREATOR_TOP_TUTORIAL_APP_LIMIT_WARNING_MESSAGE"] =
  "需要一個應用程式空位才能查看此「指南」。\n在執行此「指南」之前，請先刪除一個應用程式。";
translations["MSG_CREATOR_APP_SORT_FILTER_TITLE"] = "尋找";
translations["MSG_CREATOR_APP_KEYWORD_SEARCH_TITLE"] = "用詞搜索";
translations["MSG_CREATOR_APP_SORT_TITLE"] = "排序";
translations["MSG_CREATOR_APP_SORT_FAVORITED"] = "最受歡迎";
translations["MSG_CREATOR_APP_SORT_DATE"] = "時間";
translations["MSG_CREATOR_APP_FILTER_TITLE"] = "篩選";
translations["MSG_CREATOR_APP_FILTER_OFFICIAL"] = "官方";
translations["MSG_CREATOR_APP_FILTER_FAVORITED"] = "收藏";
translations["MSG_CREATOR_APP_DISABLE_BTN"] = "無法製作";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_TITLE"] =
  "確定要完全刪除嗎？";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_SUBTITLE"] =
  "確定要刪除「%{name}」嗎？\n完全刪除後將無法恢復。";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_TITLE"] =
  "還原至「我的應用程式」？";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_SUBTITLE"] =
  "確定要將「%{name}」還原至「我的應用程式」嗎？";
translations["MSG_CREATOR_SCREEN_LIST_HEADER"] = "頁面";
translations["MSG_CREATOR_COMPONENT_LIST_HEADER"] = "選擇中";
translations["MSG_CREATOR_MENU_CONTEXT_DELETE"] = "刪除";
translations["MSG_CREATOR_MENU_CONTEXT_COPY"] = "複製";
translations["MSG_CREATOR_MENU_RUN_APP_BTN"] = "運行應用程式";
translations["MSG_CREATOR_MENU_SET_APP_BTN"] = "設定應用程式";
translations["MSG_CREATOR_MENU_PUBLISH_APP_BTN"] = "發佈應用程式";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_APP_BTN"] = "停止發佈";
translations["MSG_CREATOR_MENU_PUBLISH_TEMPLATE_BTN"] = "發佈模板";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_TEMPLATE_BTN"] = "停止發佈模板";
translations["MSG_CREATOR_MENU_CLOSE_BTN"] = "關閉此頁面";
translations["MSG_CREATOR_MENU_COMPONENT_BTN"] = "部件";
translations["MSG_CREATOR_MENU_COMPONENT_ACTION_BTN"] = "工作";
translations["MSG_CREATOR_MENU_COMPONENT_SHAPE_BTN"] = "形狀";
translations["MSG_CREATOR_MENU_COMPONENT_STAMP_BTN"] = "印章";
translations["MSG_CREATOR_MENU_COMPONENT_STOCK_BTN"] = "道具箱";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_ACTION"] = "操作部件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_SHAPE"] = "形狀部件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP"] = "印章部件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_CHARACTER"] = "角色";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GAME"] = "活動・遊戲";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ANIMAL"] = "生物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_EVENT"] = "事件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_INTERNET"] = "互聯網";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_MONEY"] = "經濟・金錢";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GOODS"] = "生活雜貨";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_NATURE"] = "自然・植物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_PERSON"] = "人物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_BUILDING"] = "建築";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_FOOD"] = "食物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ELECTRONIC"] =
  "家電・通信";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_SMILE"] = "微笑";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_VEHICLE"] = "交通工具";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_STATIONARY"] = "文具";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_OTHERS"] = "其他";
translations["MSG_CREATOR_MENU_DRAWING_BTN"] = "繪圖";
translations["MSG_CREATOR_MENU_DRAWING_PEN"] = "筆";
translations["MSG_CREATOR_MENU_DRAWING_ERASER"] = "橡皮擦";
translations["MSG_CREATOR_MENU_DRAWING_SIZE"] = "粗細";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_LIGHT"] = "細";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_NORMAL"] = "普通";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_BOLD"] = "粗";
translations["MSG_CREATOR_MENU_DRAWING_COLOR"] = "顏色";
translations["MSG_CREATOR_MENU_DRAWING_RESET"] = "重置";
translations["MSG_CREATOR_MENU_DRAWING_FINISH"] = "完成";
translations["MSG_CREATOR_MENU_STOCK_PARTS_USE_BTN"] = "添加";
translations["MSG_CREATOR_MENU_COMPONENT_PREVIEW_TITLE"] = "%{name}的部件一覽";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_SYSTEM_TITLE"] = "圖標";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"] = "相冊";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"] = "素描簿";
translations["MSG_CREATOR_MENU_PROPERTY_BTN"] = "設計";
translations["MSG_CREATOR_MENU_PROPERTY_BASIC"] = "基本";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION"] = "位置";
translations["MSG_CREATOR_MENU_PROPERTY_SIZE"] = "尺寸";
translations["MSG_CREATOR_MENU_PROPERTY_APPEARANCE"] = "外觀";
translations["MSG_CREATOR_MENU_PROPERTY_COLOR"] = "顏色";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC"] = "程序";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC_TITLE"] = "%{name}的程序";

translations["MSG_CREATOR_MENU_PROPERTY_NAME"] = "名稱";
translations["MSG_CREATOR_MENU_PROPERTY_NAME_PLACEHOLDER"] = "請輸入名稱";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE_TITLE"] = "首頁";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE"] = "從此頁面開始";
translations["MSG_CREATOR_MENU_PROPERTY_FONT_FAMILY"] = "字體種類";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT"] = "顯示的內容";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX"] = "重疊";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_FRONT"] = "最上面";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_BACK"] = "最下面";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION_X_Y"] = "橫向和縱向位置";
translations["MSG_CREATOR_MENU_PROPERTY_X"] = "橫向位置";
translations["MSG_CREATOR_MENU_PROPERTY_Y"] = "縱向位置";
translations["MSG_CREATOR_MENU_PROPERTY_X_COORDINATE"] = "橫";
translations["MSG_CREATOR_MENU_PROPERTY_Y_COORDINATE"] = "縱";
translations["MSG_CREATOR_MENU_PROPERTY_WIDTH"] = "寬度";
translations["MSG_CREATOR_MENU_PROPERTY_HEIGHT"] = "高度";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER"] = "邊框";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW"] = "陰影";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SIZE"] = "文本";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW"] = "文本的陰影";
translations["MSG_CREATOR_MENU_PROPERTY_OPACITY"] = "可見度";
translations["MSG_CREATOR_MENU_PROPERTY_ROTATION"] = "角度";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_RADIUS"] = "邊角圓角";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO"] = "圖片的資訊";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_NAME"] = "名稱";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_SIZE"] = "大小";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_FILE_SIZE"] = "文件大小";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_BTN"] = "選擇圖片";
translations["MSG_CREATOR_MENU_PROPERTY_BACKGROUND_COLOR"] = "填充顏色";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_COLOR"] = "邊框";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW_COLOR"] = "陰影";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_COLOR"] = "文本";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW_COLOR"] = "文本的陰影";

translations["MSG_CREATOR_MENU_BLOCKLY_TITLE"] = "積木";
translations["MSG_CREATOR_MENU_BLOCKLY_EVENT"] = "事件";
translations["MSG_CREATOR_MENU_BLOCKLY_ANIMATION"] = "動畫";
translations["MSG_CREATOR_MENU_BLOCKLY_CONTROL"] = "控制";
translations["MSG_CREATOR_MENU_BLOCKLY_LOGIC"] = "邏輯";
translations["MSG_CREATOR_MENU_BLOCKLY_MATH"] = "運算";
translations["MSG_CREATOR_MENU_BLOCKLY_VARIABLE"] = "變數";
translations["MSG_CREATOR_MENU_BLOCKLY_PROCEDURE"] = "函數";
translations["MSG_CREATOR_MENU_BLOCKLY_PROMPT_INPUT_MESSAGE"] =
  "%{placeholder}的值";

translations["MSG_CREATOR_COMPONENT_NAME_SCREEN"] = "頁面";
translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"] = "按鈕";
translations["MSG_CREATOR_COMPONENT_NAME_LABEL"] = "標籤";
translations["MSG_CREATOR_COMPONENT_NAME_FORM"] = "表單";
translations["MSG_CREATOR_COMPONENT_NAME_CHECKBOX"] = "複選框";
translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"] = "開關";
translations["MSG_CREATOR_COMPONENT_NAME_IMAGE"] = "圖片";
translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"] = "圓";
translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"] = "三角形";
translations["MSG_CREATOR_COMPONENT_NAME_RECT"] = "方形";
translations["MSG_CREATOR_COMPONENT_NAME_STAR"] = "星";
translations["MSG_CREATOR_COMPONENT_NAME_LINE"] = "線";
translations["MSG_CREATOR_COMPONENT_NAME_STAMP"] = "印章";
translations["MSG_CREATOR_COMPONENT_NAME_DRAWING"] = "繪圖";
translations["MSG_CREATOR_COMPONENT_LABEL_BUTTON"] =
  translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"];
translations["MSG_CREATOR_COMPONENT_LABEL_LABEL"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LABEL"];
translations["MSG_CREATOR_COMPONENT_LABEL_FORM"] =
  translations["MSG_CREATOR_COMPONENT_NAME_FORM"];
translations["MSG_CREATOR_COMPONENT_LABEL_CHECKBOX"] = "複選\n複選框";
translations["MSG_CREATOR_COMPONENT_LABEL_SWITCH"] =
  translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"];
translations["MSG_CREATOR_COMPONENT_LABEL_IMAGE"] = "圖片\n複選框";
translations["MSG_CREATOR_COMPONENT_LABEL_CIRCLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_TRIANGLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_RECT"] =
  translations["MSG_CREATOR_COMPONENT_NAME_RECT"];
translations["MSG_CREATOR_COMPONENT_LABEL_STAR"] =
  translations["MSG_CREATOR_COMPONENT_NAME_STAR"];
translations["MSG_CREATOR_COMPONENT_LABEL_LINE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LINE"];

translations["MSG_BLOCKLY_VARIABLES"] = "變數";
translations["MSG_BLOCKLY_INPUT_NUMBER_LIMIT"] = "請輸入數字。";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] = "%{limit}字元以內。";
translations["MSG_ASSET_ALBUM_TITLE"] = "相冊內容";
translations["MSG_ASSET_DRAWING_TITLE"] = "素描簿內容";
translations["MSG_ASSET_ALBUM_ADD_TITLE"] = "添加圖片";
translations["MSG_ASSET_DRAWING_ADD_ALBUM_TITLE"] =
  "在「自由創作」中添加的圖片和照片將會添加到這裡。";
translations["MSG_ASSET_DRAWING_ADD_WARNING_TITLE"] =
  "在「自由創作」的「繪圖」選單中繪製的圖畫將會添加到這裡。";
translations["MSG_ASSET_ADD_TO_SCREEN_BTN"] = "添加到應用程式中";
translations["MSG_ASSET_DELETE_BTN"] = "刪除圖片";
translations["MSG_ASSET_ALBUM_EMPTY_MESSAGE"] = "還沒有 圖片資料。";
translations["MSG_ASSET_DRAWING_EMPTY_MESSAGE"] = "還沒有 繪圖的 資料。";
translations["MSG_REACTION_TAG_TITLE"] = "情緒印章";
translations["MSG_REACTION_USERS"] = "大家的\n情緒";
translations["MSG_REACTION_DIFFICULT"] = "有點難度！";
translations["MSG_REACTION_EASY"] = "簡單";
translations["MSG_REACTION_COOL"] = "很棒！";
translations["MSG_REACTION_FUN"] = "有趣";
translations["MSG_REACTION_AMAZING"] = "很厲害！";
translations["MSG_REACTION_BAD"] = "嗯......";
translations["MSG_CREATOR_APP_SORT_VIEWED"] = "人氣";

// User Plan
translations["MSG_CURRENT_PLAN"] = "目前方案";
translations["MSG_PLAN_TRIAL"] = "試用";
translations["MSG_PLAN_SAKIDORI"] = "搶先體驗";
translations["MSG_PLAN_FREE"] = "Free";
translations["MSG_PLAN_EDUCATION"] = "Education";
translations["MSG_PLAN_STANDARD"] = "Standard";
translations["MSG_PLAN_PROFESSIONAL"] = "Professional";
translations["MSG_PLAN_UNKNOWN"] = "未知";

export default translations;
